import styled, { css } from 'styled-components';
import { T } from '@/ui/Text/Text';
import { Flex } from '@/ui/Flex/Flex';

export const StyledAssetsCnt = styled.div`
  overflow: auto;
  max-height: 100%;
  padding-right: 24px;
  scrollbar-width: thin;
  scrollbar-color: #ccc #f0f0f0;

  &::-webkit-scrollbar {
    width: 12px;
    height: 12px;
    background-color: #f0f0f0;
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
  }

  /* For Firefox */
  &::-moz-scrollbar {
    width: 12px;
    height: 12px;
    border-radius: 12px;
  }

  &::-moz-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
  }
`;

export const StyledAssetsScrollCnt = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
`;

export const StyledSearchBar = styled(Flex)`
  background: rgba(220, 220, 220, 0.2);
  border-radius: 0.5rem;
  padding: 1rem;
`;

export const StyledAssetTypeChanger = styled.div<{
  checked: boolean;
  disabled: boolean;
}>`
  text-align: center;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  background-color: ${({ checked }) =>
    checked ? 'rgba(220, 220, 220, 0.4)' : 'transparent'};
  transition: all 0.2s ease;
  &:hover {
    background-color: rgba(220, 220, 220, 0.4);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      color: #ababab;

      &:hover {
        background-color: initial;
      }
    `}
`;

export const StyledAssetTypeChangerContainer = styled.div`
  border-radius: 0.5rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2px;
  background: rgba(220, 220, 220, 0.2);
  width: fit-content;
`;

export const StyledSlideLibraryTopBar = styled(Flex)`
  cursor: pointer;
`;

export const StyledSlideLibraryCatName = styled(T)`
  user-select: none;
`;
